<script setup lang="ts">
const { page } = useContent()

watch(
  () => page.value,
  (p) => {
    if (p) useContentHead(p)
  },
  { immediate: true },
)
</script>

<template>
  <article class="prose prose-lg dark:prose-invert max-w-3xl mx-auto">
    <slot />
  </article>
</template>
